import algoliasearch from 'algoliasearch/lite';

import EditorialConfig from '@/EditorialConfig';
import queryAlgoliaIndex from '@/utils/functions/algolia/queryAlgoliaIndex';

const queryAlgoliaPosts = (query: string, hitsPerPage: number = 10, page = 0) => {
    const client = algoliasearch(EditorialConfig.algolia.appId, EditorialConfig.algolia.key);
    const index = client.initIndex('wp_posts_post');

    return queryAlgoliaIndex(index, query, hitsPerPage, page);
};

export default queryAlgoliaPosts;
